(function(){
  /* ---------- catalog of upsell products (handles + first variant ids) ---------- */
  var CATALOG = {};
  try {
    var raw = document.getElementById('fp-cart-upsell-catalog').textContent;
    CATALOG = JSON.parse(raw);
  } catch (e) { CATALOG = {}; }

  /* slot ids that the upsell rules reference */
  var SLOTS = ['ragebag','gloves-kids','gloves-adult','suction-pad','lightning-rope','strength-bottle','mini'];

  /* fallback subtext per slot */
  var UPSELL_SUB = {
    'ragebag':         { kids: 'Burn energy. Stay active.',  adult: 'Quick hits. Instant rebound.' },
    'gloves-kids':     { kids: 'Better hits. More fun.',     adult: 'Better hits. More fun.' },
    'gloves-adult':    { kids: 'Better grip. Cleaner hits.', adult: 'Better grip. Cleaner hits.' },
    'suction-pad':     { kids: 'Stronger hold. No slipping.', adult: 'Extra stability for intense sessions.' },
    'lightning-rope':  { kids: 'Fast rhythm. Smooth movement.', adult: 'Fast rhythm. Smooth movement.' },
    'strength-bottle': { kids: 'Built for daily use.',       adult: 'Built for daily use.' },
    'mini':            { kids: 'You hold, they punch — train together with the gloves.', adult: 'You hold, they punch — train together with the gloves.' }
  };

  /* ---------- DOM refs ---------- */
  var root      = document.getElementById('fp-cart-root');
  if (!root || root.hasAttribute('data-fp-cart-ready')) return;
  var body      = root.querySelector('[data-fp-cart-body]');
  var cbCartOffer = root.querySelector('[data-cb-offer]');
  var totalEl   = root.querySelector('[data-fp-cart-total]');
  var subTxt    = root.querySelector('[data-fp-cart-sub]');
  var checkoutA = root.querySelector('[data-fp-cart-checkout]');

  /* ---------- helpers ---------- */
  function savingsReference(item, currency) {
    var original = item.original_line_price != null ? item.original_line_price : (item.final_line_price || 0);
    if (Number(item.product_id) !== 10819523117249) return original;
    var qty = item.quantity || 1;
    var unit = currency === 'USD' ? 7500 : Math.round(original / qty * 1.25);
    return Math.max(original, unit * qty);
  }
  function formatMoney(cents, currency) {
    if (cents == null || isNaN(cents)) return '—';
    var value = cents / 100;
    var hasFraction = Math.abs(value % 1) > 0.001;
    var code = (currency || 'USD').toUpperCase();
    var locale = (navigator.language || 'en-US').replace('_','-');
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency', currency: code,
        minimumFractionDigits: hasFraction ? 2 : 0,
        maximumFractionDigits: hasFraction ? 2 : 0
      }).format(value);
    } catch (e) {
      return value.toFixed(hasFraction ? 2 : 0);
    }
  }

  function setupContext() {
    try {
      var s = window.sessionStorage && window.sessionStorage.getItem('fp_setup');
      if (s === 'kids' || s === 'adult') return s;
    } catch (e) {}
    return 'kids';
  }

  function classifyHandles(cart) {
    var has = { ragebag: false, glovesKids: false, glovesAdult: false, pad: false, rope: false, bottle: false };
    var handles = {
      ragebag: CATALOG['ragebag'] && CATALOG['ragebag'].handle,
      glovesKids: CATALOG['gloves-kids'] && CATALOG['gloves-kids'].handle,
      glovesAdult: CATALOG['gloves-adult'] && CATALOG['gloves-adult'].handle,
      pad: CATALOG['suction-pad'] && CATALOG['suction-pad'].handle,
      rope: CATALOG['lightning-rope'] && CATALOG['lightning-rope'].handle,
      bottle: CATALOG['strength-bottle'] && CATALOG['strength-bottle'].handle
    };
    /* Treat the World Cup edition products (and any future edition spin-offs)
       as a Rage-Bag for upsell purposes, so those carts get the same gloves /
       pad / bottle upsells as the main Rage-Bag. Edition products share the
       'rage-bag' token AND end in 'edition' (e.g. funpunch®-rage-bag-brazil-
       edition). Replacement parts (rage-bag-replacement-*) are excluded since
       they don't end in 'edition'. */
    function isRagebagLike(h) {
      if (!h) return false;
      if (h === handles.ragebag) return true;
      if (h.indexOf('rage-bag') !== -1 && /edition$/i.test(h)) return true;
      return false;
    }
    if (!cart || !cart.items) return has;
    for (var i = 0; i < cart.items.length; i++) {
      var h = cart.items[i].handle || '';
      if (isRagebagLike(h)) has.ragebag = true;
      if (h === handles.glovesKids) has.glovesKids = true;
      if (h === handles.glovesAdult) has.glovesAdult = true;
      if (h === handles.pad) has.pad = true;
      if (h === handles.rope) has.rope = true;
      if (h === handles.bottle) has.bottle = true;
    }
    return has;
  }

  /* Smart upsells, max 2, mirrors brief §12 rules. */
  function computeUpsells(cart) {
    var has = classifyHandles(cart);
    var setup = setupContext();
    var picks = [];

    function pushIf(slot, cond) {
      if (!CATALOG[slot] || !CATALOG[slot].variantId) return;
      if (picks.indexOf(slot) !== -1) return;
      if (cond) picks.push(slot);
    }

    if (has.ragebag) {
      var glovesSlot = setup === 'adult' ? 'gloves-adult' : 'gloves-kids';
      var hasThisGloves = (setup === 'adult') ? has.glovesAdult : has.glovesKids;
      pushIf(glovesSlot, !hasThisGloves);
      pushIf('suction-pad', !has.pad);
      if (picks.length < 2) pushIf('strength-bottle', !has.bottle);
      if (picks.length < 2 && setup === 'adult') pushIf('lightning-rope', !has.rope);
    } else if (has.glovesAdult || has.glovesKids) {
      pushIf('ragebag', !has.ragebag);
      pushIf('suction-pad', !has.pad);
    } else if (has.rope) {
      pushIf('strength-bottle', !has.bottle);
      pushIf('gloves-adult', !(has.glovesAdult || has.glovesKids));
    } else if (has.bottle) {
      pushIf('lightning-rope', !has.rope);
      pushIf('ragebag', !has.ragebag);
    } else if (has.pad) {
      pushIf('ragebag', !has.ragebag);
    }
    /* Punch Mitts forced-upsell removed 2026-07-01 (demand test closed — winner). Back to a 2-upsell cap. */
    return picks.slice(0, 2);
  }

  /* ---------- rendering ---------- */
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }

  var INCLUDED_IDS = [50718611865793, 50718612226241];
  var BAG_IDS = [10819523117249,10977177010369,11058706088129,11089582162113,11097593348289];
  function isIncluded(item) { return INCLUDED_IDS.indexOf(Number(item.variant_id || item.id)) !== -1; }
  function syncIncluded(cart) {
    var eligible = cart.items.some(function(i){return BAG_IDS.indexOf(Number(i.product_id)) !== -1;});
    var updates = {}, missing = [];
    INCLUDED_IDS.forEach(function(id){
      var lines = cart.items.filter(function(i){return Number(i.variant_id || i.id) === id;});
      lines.forEach(function(i,n){var qty = eligible && n === 0 ? 1 : 0;if(i.quantity !== qty)updates[i.key]=qty;});
      if(eligible && !lines.length)missing.push({id:id,quantity:1,properties:{_fp_included:'true',_fulfilment:'Already included; do not pack separately'}});
    });
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function post(path,data){return fetch(base+path,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)}).then(function(r){if(!r.ok)throw new Error('Included items could not be updated');return r.json();});}
    var run=Object.keys(updates).length?post('cart/update.js',{updates:updates}):Promise.resolve(cart);
    return run.then(function(current){
      if(!missing.length)return current;
      return post('cart/add.js',{items:missing,sections:['fp-cart-state'],sections_url:window.location.pathname}).then(function(data){
        var section=data.sections && data.sections['fp-cart-state'];
        if(section){var doc=new DOMParser().parseFromString(section,'text/html');var state=doc.querySelector('[data-fp-cart-state]');if(state)return JSON.parse(state.textContent);}
        return fetch(base+'cart.js').then(function(r){return r.json();});
      });
    });
  }
  function renderIncluded(item, currency) {
    var app=Number(item.variant_id || item.id)===INCLUDED_IDS[1];
    return '<div class="fp-cart-line fp-cart-bonus"><div class="fp-cart-line__thumb" aria-hidden="true" style="font-size:25px">'+(app?'<img src="'+escapeHtml(root.getAttribute('data-app-gift-image') || '')+'" alt="FUNPUNCH app boxing lesson" width="46" height="58" style="width:46px;height:58px;object-fit:cover">':'🎁')+'</div><div class="fp-cart-line__info"><div class="fp-cart-line__row"><h3 class="fp-cart-line__title">'+(app?'FUNPUNCH App Access':'Mystery Gift')+'</h3><span style="display:flex;align-items:center;gap:7px;white-space:nowrap"><s style="font-size:12px;color:#777">'+formatMoney(item.original_line_price,currency)+'</s><strong style="color:#bf470e;font-size:12px;font-weight:900;letter-spacing:.025em">'+(item.final_line_price===0?'FREE':formatMoney(item.final_line_price,currency))+'</strong></span></div><div class="fp-cart-line__variant">'+(app?'Included app access · No subscription':'Already included with your bag')+'</div></div></div>';
  }

  function renderLine(item, currency) {
    if (isIncluded(item)) return renderIncluded(item, currency);
    /* Cart JSON returns the ORIGINAL image URL (these are up to 2364x2364 PNGs),
       and it renders in a ~46px box. Ask for a thumbnail instead. */
    var img = cdnResize(
      (item.featured_image && item.featured_image.url) ? item.featured_image.url : (item.image || ''),
      140
    );
    var title = Number(item.product_id) === 10819523117249 ? 'The FUNPUNCH bag' : (item.product_title || item.title || 'Product');
    var variantTitle = '';
    if (item.variant_title && item.variant_title !== 'Default Title') variantTitle = item.variant_title;

    /* Show readable cart properties. Skip:
       - underscore-prefixed (private — bundle IDs, etc.)
       - "Bag #" labels (can desync if customer removes bundle items individually) */
    var HIDDEN_PROPS = { 'Bag #': true, 'Bag': true, 'Setup': true, 'Color': true };
    var propsHtml = '';
    if (item.properties) {
      var pairs = [];
      for (var k in item.properties) {
        if (!Object.prototype.hasOwnProperty.call(item.properties, k)) continue;
        if (k.indexOf('_') === 0) continue;
        if (HIDDEN_PROPS[k]) continue;
        var v = item.properties[k];
        if (!v) continue;
        pairs.push('<span>' + escapeHtml(k) + ': ' + escapeHtml(v) + '</span>');
      }
      if (pairs.length) propsHtml = '<div class="fp-cart-line__props">' + pairs.join('') + '</div>';
    }

    /* Pre-compute the price HTML so we can plug it into the template below. */
    var origLP = savingsReference(item, currency);
    var finalLP = item.final_line_price;
    var priceHtml;
    if (origLP != null && finalLP != null && origLP > finalLP + 1) {
      var pct = Math.round((origLP - finalLP) / origLP * 100);
      priceHtml = '<div class="fp-cart-line__price-stack">'
        + '<span class="fp-cart-line__price-strike">' + formatMoney(origLP, currency) + '</span>'
        + '<div class="fp-cart-line__price">' + formatMoney(finalLP, currency) + '</div>'
        + '<span class="fp-cart-line__save">Save ' + pct + '%</span>'
        + '</div>';
    } else {
      priceHtml = '<div class="fp-cart-line__price">' + formatMoney(finalLP, currency) + '</div>';
    }

    return ''
      + '<div class="fp-cart-line" data-fp-cart-line data-line-key="' + escapeHtml(item.key) + '"'
      +      ' data-variant-id="' + escapeHtml(String(item.variant_id || item.id || '')) + '"'
      +      ' data-props-sig="' + escapeHtml(propsSignature(item)) + '"'
      +      ' data-line-subtotal="' + String(item.final_line_price != null ? item.final_line_price : (item.line_price || 0)) + '"'
      +      ' data-unit-price="' + String(item.final_price != null ? item.final_price : (item.price || 0)) + '">'
      +   '<div class="fp-cart-line__thumb">'
      +     (img ? '<img src="' + escapeHtml(img) + '" alt="" decoding="async" fetchpriority="high" width="46" height="46">' : '')
      +   '</div>'
      +   '<div class="fp-cart-line__info">'
      +     '<div class="fp-cart-line__row">'
      +       '<h3 class="fp-cart-line__title' + (Number(item.product_id) === 10819523117249 ? ' fp-cart-line__title--bag' : '') + '">' + escapeHtml(title) + '</h3>'
      +       priceHtml
      +     '</div>'
      +     (variantTitle ? '<div class="fp-cart-line__variant">' + escapeHtml(variantTitle) + '</div>' : '')
      +     propsHtml
      +     '<div class="fp-cart-line__controls">'
      +       '<div class="fp-cart-qty">'
      +         '<button type="button" data-fp-qty-delta="-1" aria-label="Decrease">−</button>'
      +         '<span class="fp-cart-qty__val">' + (item.quantity || 1) + '</span>'
      +         '<button type="button" data-fp-qty-delta="1" aria-label="Increase">+</button>'
      +       '</div>'
      +       '<button class="fp-cart-remove" type="button" data-fp-cart-remove>Remove</button>'
      +     '</div>'
      +   '</div>'
      + '</div>';
  }

  /* Free App License bonus row — shown when the cart contains a Rage-Bag. Display-only (not a real line item). */
  function renderBonusApp() {
    return ''
      + '<div class="fp-cart-line fp-cart-bonus" aria-label="Free FUNPUNCH app license included with your Rage-Bag">'
      +   '<div class="fp-cart-line__thumb fp-cart-bonus__thumb">'
      +     '<svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="#E5311B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg>'
      +   '</div>'
      +   '<div class="fp-cart-line__info">'
      +     '<div class="fp-cart-line__row">'
      +       '<h3 class="fp-cart-line__title">FUNPUNCH App License</h3>'
      +       '<span class="fp-cart-bonus__free">FREE</span>'
      +     '</div>'
      +     '<div class="fp-cart-line__variant">Included free with your Rage-Bag</div>'
      +   '</div>'
      + '</div>';
  }

  /* PERF 2026-08-27 — pre-warm the upsell thumbnails.
     The catalog is known at page load (inline JSON), but the <img> tags are only
     created after the cart fetch resolves, so the first drawer open always paid the
     full image download (~810ms each, measured). Warm them once the page is done,
     at idle and low priority, so they are already in cache. 6 thumbs at 140px. */
  (function warmUpsellThumbs() {
    var started = false;
    function warm() {
      if (started) return;
      started = true;
      try {
        Object.keys(CATALOG).forEach(function (k) {
          var u = CATALOG[k] && CATALOG[k].image;
          if (!u) return;
          var im = new Image();
          try { im.fetchPriority = 'low'; } catch (e) {}
          im.decoding = 'async';
          im.src = u;
        });
      } catch (e) {}
    }
    function schedule() {
      if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 4000 });
      else setTimeout(warm, 2500);
    }
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
    /* if the shopper reaches the cart before idle fires, warm immediately */
    document.addEventListener('fp:cart:open', warm);

    /* PERF 2026-08-27 — the cart LINE thumb is the product being added, and its
       140px URL is only built after /cart.js returns (~900ms fresh, measured).
       The same image is already on screen as the PDP hero, so warm its 140px
       variant the moment the drawer is asked to open — that runs in parallel with
       the cart request instead of after it. Re-runs per open, since the shopper
       may have switched variant. */
    document.addEventListener('fp:cart:open', function () {
      try {
        var hero = document.querySelector('[data-fp-pdp-hero-img]');
        var src = hero && (hero.currentSrc || hero.src);
        if (!src) return;
        var im = new Image();
        try { im.fetchPriority = 'high'; } catch (e) {}
        im.decoding = 'async';
        im.src = cdnResize(src, 140);
      } catch (e) {}
    });
  })();

  function renderUpsell(slot, setup) {
    var p = CATALOG[slot];
    if (!p) return '';
    var sub = (UPSELL_SUB[slot] && (UPSELL_SUB[slot][setup] || UPSELL_SUB[slot].adult || UPSELL_SUB[slot].kids)) || '';
    var img = p.image || '';
    return ''
      + '<div class="fp-cart-upsell" data-fp-upsell-slot="' + slot + '">'
      +   '<div class="fp-cart-upsell__thumb">'
      +     (img ? '<img src="' + escapeHtml(img) + '" alt="" decoding="async" fetchpriority="high" width="44" height="44">' : '')
      +   '</div>'
      +   '<div class="fp-cart-upsell__info">'
      +     '<h4 class="fp-cart-upsell__title">' + escapeHtml(p.title || '') + '</h4>'
      +     (sub ? '<div class="fp-cart-upsell__sub">' + escapeHtml(sub) + '</div>' : '')
      +     '<div class="fp-cart-upsell__price">' + escapeHtml(p.priceFormatted || '') + '</div>'
      +   '</div>'
      +   '<button class="fp-cart-upsell__btn" type="button" data-fp-upsell-add="' + p.variantId + '">Add</button>'
      + '</div>';
  }

  var BIG_OFFER={};try{BIG_OFFER=JSON.parse(document.getElementById('fp-big-offer-catalog').textContent)}catch(e){}
  function bigOfferEligible(cart){return cart.items.some(function(i){return i.product_id===11058706088129})&&!cart.items.some(function(i){return i.product_id===10819523117249})}
  function renderBigOffer(cart){if(!bigOfferEligible(cart))return '';var variants=(BIG_OFFER.variants||[]).filter(function(v){return v.available});if(!variants.length)return '';var v=variants[0];return '<div class="fp-big-cart-offer"><span class="fp-big-cart-offer__badge">Your Big Rage Bag offer · Save 60%</span><h3>Add the original FUNPUNCH Bag</h3><div class="fp-big-cart-offer__row"><img data-offer-img src="'+escapeHtml(v.image)+'" alt="Original FUNPUNCH Bag"><div><p>A smaller bag for quick hits.</p><s data-offer-original>'+formatMoney(v.price,cart.currency)+'</s><strong data-offer-price>'+formatMoney(v.price-Math.round(v.price*.6),cart.currency)+'</strong></div></div><label>Choose your design<select data-big-offer-select data-currency="'+escapeHtml(cart.currency)+'">'+variants.map(function(x){return '<option value="'+x.id+'">'+escapeHtml(x.title)+'</option>'}).join('')+'</select></label><button type="button" data-fp-upsell-add="'+v.id+'">Add for 60% off</button><p>One discounted original bag with your Big Rage Bag. Applied automatically at checkout.</p></div>'}
  root.addEventListener('change',function(e){if(!e.target.matches('[data-big-offer-select]'))return;var v=BIG_OFFER.variants.find(function(v){return String(v.id)===e.target.value});if(!v)return;var box=e.target.closest('.fp-big-cart-offer');box.querySelector('[data-fp-upsell-add]').setAttribute('data-fp-upsell-add',v.id);box.querySelector('[data-offer-img]').src=v.image;box.querySelector('[data-offer-original]').textContent=formatMoney(v.price,e.target.dataset.currency);box.querySelector('[data-offer-price]').textContent=formatMoney(v.price-Math.round(v.price*.6),e.target.dataset.currency)});

  function render(cart) {
    var currency = cart && cart.currency;
    /* Always reset the savings panel — if no cart, no savings */
    var savingsElReset = root.querySelector('[data-fp-cart-savings]');
    if (savingsElReset) savingsElReset.hidden = true;

    if (!cart || !cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="fp-cart-empty">'
        + '<div class="fp-cart-empty-title">Your cart is empty</div>'
        + '<div>Add a Rage-Bag and your set-up.</div>'
        + '</div>';
      if (totalEl) totalEl.textContent = formatMoney(0, currency);
      if (checkoutA) { checkoutA.style.pointerEvents = 'none'; checkoutA.style.opacity = '0.55'; }
      return;
    }

    var html = '<div class="fp-cart-items-card">';
    for (var i = 0; i < cart.items.length; i++) if (!isIncluded(cart.items[i])) html += renderLine(cart.items[i], currency);
    INCLUDED_IDS.forEach(function(id){cart.items.filter(function(item){return Number(item.variant_id || item.id)===id;}).forEach(function(item){html += renderIncluded(item,currency);});});
    /* Free "FUNPUNCH App License" bonus row disabled 2026-07-27 — dialing back app promotion in cart.
       renderBonusApp() kept below (unused) so this can be re-enabled by restoring this line. */
    /* if (classifyHandles(cart).ragebag) html += renderBonusApp(); */
    html += '</div>';

    /* Cart contains selected items only; all cart upsells disabled. */
    body.innerHTML = html;
    if (cbCartOffer && classifyHandles(cart).ragebag && !cart.items.some(function(item){return String(item.product_id) === cbCartOffer.dataset.productId;})) body.appendChild(cbCartOffer);

    shownSubtotal = cart.total_price;
    shownCurrency = currency;
    if (totalEl) totalEl.textContent = formatMoney(shownSubtotal, currency);
    clearTotalRecalculating();
    if (subTxt) {
      var n = cart.items.reduce(function(n,i){return n+(isIncluded(i)?0:i.quantity);},0);
      subTxt.textContent = n === 1 ? '1 item · Almost ready.' : n + ' items · Almost ready.';
    }
    if (checkoutA) { checkoutA.style.pointerEvents = ''; checkoutA.style.opacity = ''; }

    /* Cart-level savings badge. We compute it from the difference between the
       sum of original_line_price and the sum of final_line_price (covers both
       cart-level discounts and line-level discounts). */
    var savingsEl = root.querySelector('[data-fp-cart-savings]');
    var savingsAmtEl = root.querySelector('[data-fp-cart-savings-amount]');
    if (savingsEl && savingsAmtEl) {
      var originalSum = 0, finalSum = 0;
      for (var s = 0; s < cart.items.length; s++) {
        var it = cart.items[s];
        originalSum += savingsReference(it, currency);
        finalSum   += (it.final_line_price != null ? it.final_line_price : 0);
      }
      var savings = originalSum - (cart.total_price != null ? cart.total_price : finalSum);
      /* Also include cart-level discounts (Shopify Automatic Discount) */
      if (cart.total_discount && cart.total_discount > savings) savings = cart.total_discount;
      if (savings > 1) {
        savingsAmtEl.textContent = '−' + formatMoney(savings, currency);
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }
  }

  /* ---------- Shopify Ajax cart helpers ---------- */
  function checkBigOfferGift(cart) {
    var items=cart.items||[];
    var qualifies=items.some(function(i){return i.product_id===11058706088129;}) && items.some(function(i){return i.product_id===10819523117249 && i.final_line_price<i.original_line_price;});
    if(qualifies)return cart;
    var updates={};
    items.forEach(function(i){if(i.properties && i.properties._big_bag_offer_gift==='true')updates[i.key]=0;});
    if(!Object.keys(updates).length)return cart;
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:updates})}).then(function(r){return r.json();});
  }
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(checkBigOfferGift).then(syncIncluded);
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); }).then(checkBigOfferGift).then(syncIncluded);
  }
  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function(r){ return r.json(); });
  }

  /* Immediate feedback on the total.

     We deliberately do NOT compute the new subtotal client-side. This store uses
     quantity-break pricing (e.g. "$66 each" at 2+), so removing one line reprices
     the remaining lines — subtracting a single line's price gives a wrong number,
     and a wrong price in a cart is worse than a slow one. Instead we flag the total
     as recalculating the instant the shopper taps, and render() fills in the real
     figure from Shopify. */
  var shownSubtotal = null;
  var shownCurrency = null;
  function markTotalRecalculating() {
    if (totalEl) totalEl.classList.add('is-recalculating');
    var sav = root.querySelector('[data-fp-cart-savings]');
    if (sav) sav.classList.add('is-recalculating');
  }
  function clearTotalRecalculating() {
    if (totalEl) totalEl.classList.remove('is-recalculating');
    var sav = root.querySelector('[data-fp-cart-savings]');
    if (sav) sav.classList.remove('is-recalculating');
  }

  /* Ask Shopify's CDN for an appropriately-sized image. Cart JSON and the gallery
     data both hand back large URLs (originals up to 2364px, gallery at width=1400),
     and they were being poured into 46-120px boxes. */
  function cdnResize(url, w) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* A line's identity that survives cart writes.
     Shopify regenerates every line item key on each mutation, so the key we
     rendered with is dead as soon as any other line changes. variant_id plus the
     line's properties is stable, so we match on that and look the live key up
     immediately before writing. */
  function propsSignature(item) {
    var p = item && item.properties;
    if (!p) return '';
    try {
      var keys = [];
      for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) keys.push(k); }
      keys.sort();
      return keys.map(function(k){ return k + '=' + p[k]; }).join('|');
    } catch (e) { return ''; }
  }

  /* Resolve the CURRENT key for a line, or null if it's already gone. */
  function currentKeyFor(variantId, propsSig) {
    return fetchCart().then(function(cart){
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].variant_id) !== String(variantId)) continue;
        if (propsSignature(items[i]) !== propsSig) continue;
        return items[i].key;
      }
      return null;
    });
  }

  /* ---------- serialised cart mutations ----------
     Every cart write goes through one queue. Shopify handles cart writes per
     session, and two concurrent /cart/change.js calls can clobber each other —
     that's why removing two lines quickly sometimes only removed one.

     We also only repaint once the queue has drained. An earlier response is a
     snapshot of the cart BEFORE the later removals landed, so rendering it would
     resurrect a row the shopper already deleted (the flicker + lag). */
  var cartQueue = Promise.resolve();
  var pendingMutations = 0;

  function queueMutation(fn) {
    pendingMutations++;
    var run = cartQueue.then(fn, fn);
    cartQueue = run.catch(function(){});           /* keep the chain alive after a failure */
    function settle(){ pendingMutations = Math.max(0, pendingMutations - 1); }
    return run.then(
      function(res){ settle(); return res; },
      function(err){ settle(); throw err; }
    );
  }
  function isLastMutation(){ return pendingMutations === 0; }
  if(checkoutA)checkoutA.addEventListener('click',function(e){
    e.preventDefault();
    queueMutation(function(){return fetchCart();}).then(function(cart){
      if(cart.items.some(function(i){return !isIncluded(i);}))window.location.assign(checkoutA.href);
      else render(cart);
    }).catch(function(){refreshCart();});
  });



  /* Remove a line optimistically: flash it red and collapse it away the instant
     the shopper taps, instead of standing still until the server replies. */
  var REMOVE_ANIM_MS = 300;
  function removeLineOptimistically(line) {
    markBusy();
    var variantId = line && line.getAttribute('data-variant-id');
    var propsSig  = line ? (line.getAttribute('data-props-sig') || '') : '';
    if (line) {
      /* Flag the total as recalculating right away, so the row vanishing and the
         price changing feel like one action rather than two. */
      markTotalRecalculating();
      line.classList.add('is-removing');
      /* Lock the current height so the collapse has a value to animate from. */
      line.style.height = line.getBoundingClientRect().height + 'px';
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){ line.classList.add('is-collapsing'); });
      });
    }
    var animDone = new Promise(function(r){ setTimeout(r, REMOVE_ANIM_MS); });
    var mutation = queueMutation(function(){
      return currentKeyFor(variantId, propsSig).then(function(liveKey){
        if (!liveKey) return fetchCart();      /* already gone — just re-sync */
        return changeLine(liveKey, 0);
      });
    });
    return Promise.all([ mutation, animDone ])
      .then(function(vals){ if (isLastMutation()) render(vals[0]); })
      .catch(function(){ if (isLastMutation()) refreshCart(); });
  }

  /* ---------- open / close ---------- */
  var lastFocus = null;

  /* Placeholder shown while an add-to-cart is still in flight. Callers (e.g. the
     PDP buy button) open the drawer the moment the shopper taps rather than after
     their request lands, so the drawer needs something to show for ~300ms. */
  function showAddingPlaceholder() {
    body.innerHTML = '<div class="fp-cart-items-card">'
      + '<div class="fp-cart-line fp-cart-skel-line" aria-hidden="true">'
      +   '<div class="fp-cart-skel fp-cart-skel--thumb"></div>'
      +   '<div class="fp-cart-line__info">'
      +     '<div class="fp-cart-skel fp-cart-skel--title"></div>'
      +     '<div class="fp-cart-skel fp-cart-skel--sub"></div>'
      +   '</div>'
      + '</div></div>'
      + '<div class="fp-cart-adding">Adding to your cart…</div>';
  }

  var pendingAddTimer = null;
  function openCart(pendingAdd) {
    var alreadyOpen = root.classList.contains('is-open');
    if (!alreadyOpen) {
      lastFocus = document.activeElement;
      document.documentElement.style.overflow = 'hidden';
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
    }
    if (pendingAdd) {
      showAddingPlaceholder();
      /* Safety net: if the caller never fires fp:cart:refresh (network error),
         don't leave the shopper staring at a skeleton. */
      clearTimeout(pendingAddTimer);
      pendingAddTimer = setTimeout(refreshCart, 4000);
      return;
    }
    if (!alreadyOpen) refreshCart();
  }
  function closeCart() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function refreshCart() {
    clearTimeout(pendingAddTimer);
    return fetchCart().then(render).catch(function(){
      body.innerHTML = '<div class="fp-cart-empty"><div>Sorry, we couldn\'t load your cart. <a href="/cart">View it here</a>.</div></div>';
    });
  }

  var discountForm=root.querySelector('[data-fp-discount-form]');
  if(discountForm)discountForm.addEventListener('submit',async function(e){
    e.preventDefault();var input=discountForm.elements.discount,code=input.value.trim(),status=discountForm.querySelector('[data-fp-discount-status]'),button=discountForm.querySelector('button');if(!code)return;
    button.disabled=true;status.textContent='Checking code…';
    try{var current=await fetchCart();var codes=(current.discount_codes||[]).filter(function(d){return d.applicable;}).map(function(d){return d.code;});if(!codes.some(function(c){return c.toLowerCase()===code.toLowerCase();}))codes.push(code);
      var response=await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:codes.join(',')})});if(!response.ok)throw Error('Could not apply the code. Please try again.');var cart=await response.json();cart=await checkBigOfferGift(cart);render(cart);
      var valid=(cart.discount_codes||[]).some(function(d){return d.code.toLowerCase()===code.toLowerCase()&&d.applicable;});status.textContent=valid?'Code applied.':'This code is not valid for the items in your cart.';
    }catch(err){status.textContent=err.message;}finally{button.disabled=false;}
  });
  /* ---------- events ---------- */
  /* Open via custom event. Pass { detail: { pending: true } } to open instantly
     while an add request is still in flight, then fire `fp:cart:refresh`. */
  document.addEventListener('fp:cart:open', function(e){
    openCart(!!(e && e.detail && e.detail.pending));
  });
  document.addEventListener('fp:cart:refresh', function(e){
    clearTimeout(pendingAddTimer);
    if (e.detail && e.detail.cart) { render(e.detail.cart); queueMutation(function(){return syncIncluded(e.detail.cart);}).then(function(cart){if(isLastMutation())render(cart);}).catch(function(){ refreshCart(); }); }
    else refreshCart();
  });
  root.setAttribute('data-fp-cart-ready', 'true');
  if (root.hasAttribute('data-fp-cart-queued')) {
    root.removeAttribute('data-fp-cart-queued');
    refreshCart();
  }

  /* "Cart busy" guard: prevent overlay-close clicks for a short window after
     any cart mutation. Stops rapid Remove taps from accidentally closing the
     drawer when the cart shrinks and the next tap lands on the overlay. */
  var lastCartActionAt = 0;
  function markBusy() { lastCartActionAt = Date.now(); }
  function isBusyNow() { return Date.now() - lastCartActionAt < 500; }

  /* Close handlers */
  root.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('[data-fp-cart-close]')) {
      /* If a cart mutation happened in the last 500ms, this click was almost
         certainly a stray rapid tap — ignore it. */
      if (isBusyNow()) return;
      closeCart();
      return;
    }

    /* qty +/- */
    var q = e.target.closest && e.target.closest('[data-fp-qty-delta]');
    if (q) {
      var line = q.closest('[data-fp-cart-line]');
      var key  = line && line.getAttribute('data-line-key');
      var delta = parseInt(q.getAttribute('data-fp-qty-delta'), 10);
      var valEl = line && line.querySelector('.fp-cart-qty__val');
      var current = valEl ? parseInt(valEl.textContent, 10) || 1 : 1;
      var nextQty = Math.max(0, current + delta);
      if (!key) return;
      if (line && line.classList.contains('is-removing')) return;
      markBusy();
      /* Dropping to 0 is a removal — animate it out like the Remove button. */
      if (nextQty === 0) { removeLineOptimistically(line); return; }
      /* Otherwise update the number instantly, then confirm with the server. */
      if (valEl) valEl.textContent = String(nextQty);
      markTotalRecalculating();
      if (line) line.classList.add('is-pending');
      var qVariantId = line && line.getAttribute('data-variant-id');
      var qPropsSig  = line ? (line.getAttribute('data-props-sig') || '') : '';
      queueMutation(function(){
        return currentKeyFor(qVariantId, qPropsSig).then(function(liveKey){
          if (!liveKey) return fetchCart();
          return changeLine(liveKey, nextQty);
        });
      })
        .then(function(cart){ if (isLastMutation()) render(cart); })
        .catch(function(){ if (isLastMutation()) refreshCart(); });
      return;
    }

    /* remove */
    var rm = e.target.closest && e.target.closest('[data-fp-cart-remove]');
    if (rm) {
      var line2 = rm.closest('[data-fp-cart-line]');
      var key2  = line2 && line2.getAttribute('data-line-key');
      if (!key2) return;
      /* If this line is already animating out (rapid double-tap), ignore */
      if (line2.classList.contains('is-removing')) return;
      removeLineOptimistically(line2);
      return;
    }

    /* upsell add */
    var up = e.target.closest && e.target.closest('[data-fp-upsell-add]');
    if (up) {
      var vid = parseInt(up.getAttribute('data-fp-upsell-add'), 10);
      if (!vid) return;
      up.disabled = true;
      markBusy();
      queueMutation(function(){
        return addToCart(vid).then(function(){ return fetchCart(); });
      }).then(function(cart){
        up.disabled = false;
        if (isLastMutation()) render(cart);
      }).catch(function(){
        up.disabled = false;
        if (isLastMutation()) refreshCart();
      });
      return;
    }

    /* mini modal thumbnail → swap main image */
    var cartMiniThumb = e.target.closest && e.target.closest('[data-fp-cart-mini-thumb]');
    if (cartMiniThumb) {
      var cartMainImg = root.querySelector('[data-fp-cart-mini-main]');
      if (cartMainImg) cartMainImg.src = cartMiniThumb.getAttribute('data-fp-cart-mini-thumb');
      var cThumbs = root.querySelectorAll('[data-fp-cart-mini-thumb]');
      for (var cti = 0; cti < cThumbs.length; cti++){ cThumbs[cti].classList.toggle('is-active', cThumbs[cti] === cartMiniThumb); }
      return;
    }
    /* mini rage-bag info modal — open */
    if (e.target.closest && e.target.closest('[data-fp-cart-mini-info]')) {
      var mmOpen = root.querySelector('[data-fp-cart-mini-modal]');
      if (mmOpen) mmOpen.hidden = false;
      return;
    }
    /* mini rage-bag info modal — close (backdrop, X, or Got it) */
    if (e.target.closest && e.target.closest('[data-fp-cart-mini-modal-close]')) {
      var mmClose = root.querySelector('[data-fp-cart-mini-modal]');
      if (mmClose) mmClose.hidden = true;
      return;
    }
  });

  /* Esc to close */
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && root.classList.contains('is-open')) closeCart();
  });

  /* Intercept any <a href="/cart"> click to open drawer instead.
     Skip if user holds modifier keys (open in new tab) or right-clicks. */
  document.addEventListener('click', function(e){
    if (e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    /* Match /cart and /cart/ but NOT /cart/anything-else (e.g. /cart/checkout). */
    if (href === '/cart' || href === '/cart/' || /^\/cart(\?.*)?$/.test(href)) {
      e.preventDefault();
      openCart();
    }
  });
})();

/* ===========================================================
   FP PDP — Sticky bottom Buy bar (mobile/tablet only).
   Mirrors the main "Get Yours" CTA. Slides in when the real CTA
   scrolls out of view and slides out when the user scrolls back.
   Clicks on this bar synthesise a click on the real button so the
   section's add-to-cart logic runs untouched.
   =========================================================== */
(function(){
  if (typeof window === 'undefined') return;

  function init() {
    var mainBuyBtn = document.querySelector('[data-fp-pdp-buy]');
    if (!mainBuyBtn) return;
    if (document.querySelector('.fp-sticky-buy')) return;   /* never double-mount */

    var totalEl = document.querySelector('[data-fp-pdp-total]');
    var labelEl = document.querySelector('[data-fp-pdp-buy-label]');
    var lockedLabel = mainBuyBtn.getAttribute('data-fp-pdp-buy-label-locked') || '';

    var bar = document.createElement('div');
    bar.className = 'fp-sticky-buy';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.innerHTML =
      '<div class="fp-sticky-buy__inner">' +
        '<button class="fp-sticky-buy__cta" type="button" data-fp-sticky-cta>' +
          '<span data-fp-sticky-label>Add to cart</span>' +
          '<span class="fp-sticky-buy__price" data-fp-sticky-price></span>' +
        '</button>' +
      '</div>';
    document.body.appendChild(bar);

    var cta    = bar.querySelector('[data-fp-sticky-cta]');
    var sLabel = bar.querySelector('[data-fp-sticky-label]');
    var sPrice = bar.querySelector('[data-fp-sticky-price]');

    /* A required choice is still outstanding (e.g. World Cup country not picked). */
    function isLocked() {
      if (mainBuyBtn.disabled) return true;
      if (lockedLabel && labelEl && labelEl.textContent.trim() === lockedLabel.trim()) return true;
      return false;
    }

    /* Mirror the buy box: same label state, same live total (bundle + add-ons). */
    function sync() {
      var locked = isLocked();
      cta.classList.toggle('is-locked', locked);
      if (locked) {
        sLabel.textContent = lockedLabel || 'Choose an option';
        sPrice.textContent = '';
      } else {
        sLabel.textContent = 'Add to cart';
        sPrice.textContent = totalEl ? totalEl.textContent.trim() : '';
      }
    }

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      if (isLocked()) {
        /* Don't fail silently — take them to the choice they still need to make. */
        var target = document.querySelector('.fp-pdp__variants') || mainBuyBtn;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      /* Delegate to the real button so bundle config, add-ons, line-item
         properties, the cart drawer and error handling all stay identical.
         No duplicated cart logic here on purpose. */
      mainBuyBtn.click();
    });

    /* Only show the bar once the shopper has scrolled PAST the buy box.

       Deliberately not shown near the top of the page: the 2-bag bundle is
       preselected as "Most Popular", so a tap before they reach the bundle
       selector would silently add two bags they never chose. By the time the bar
       appears they have scrolled through the bundle options, the add-ons and the
       buy box itself, so the configuration on the button is one they've seen. */
    function setVisible(v) { bar.classList.toggle('is-visible', v); }
    function scrolledPastBuyBox(rect) { return rect.bottom < 0; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var en = entries[i];
          setVisible(!en.isIntersecting && scrolledPastBuyBox(en.boundingClientRect));
        }
      }, { threshold: 0 }).observe(mainBuyBtn);
    } else {
      var onScroll = function () {
        setVisible(scrolledPastBuyBox(mainBuyBtn.getBoundingClientRect()));
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    /* Keep the mirrored price/label current. Scoped to two small elements only —
       deliberately not a document-wide observer. sync() writes solely to the
       sticky bar, so it can never retrigger these. */
    if ('MutationObserver' in window) {
      var opts = { childList: true, characterData: true, subtree: true };
      if (totalEl) new MutationObserver(sync).observe(totalEl, opts);
      if (labelEl) new MutationObserver(sync).observe(labelEl, opts);
    }
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 120); });
  } else {
    setTimeout(init, 120);   /* let the section JS finish wiring the buy button */
  }
})();

/* ===========================================================
   FP PDP — Variant deep-linking.
   1. On page load: honor ?variant=<id> URL parameter by auto-clicking
      the matching variant pill (so hero image + design slots sync).
   2. On variant pill click: update the URL (no page reload) so the
      address bar always reflects the selected variant — making it
      trivial to copy a shareable deep-link.
   =========================================================== */
(function(){
  if (typeof window === 'undefined') return;
  function applyDeepLinkedVariant() {
    try {
      var url = new URL(window.location.href);
      var variantId = url.searchParams.get('variant');
      if (!variantId) return;
      var pill = document.querySelector('[data-fp-pdp-variant="' + variantId + '"]');
      if (!pill) return;
      if (pill.classList.contains('is-active')) return;
      pill.click();
    } catch (e) {}
  }
  function syncUrlToVariant() {
    document.addEventListener('click', function(e){
      var pill = e.target.closest && e.target.closest('[data-fp-pdp-variant]');
      if (!pill) return;
      var vid = pill.getAttribute('data-fp-pdp-variant');
      if (!vid) return;
      /* Wait a tick to let the section's click handler run first */
      setTimeout(function(){
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', vid);
          history.replaceState({}, '', url.toString());
        } catch (e) {}
      }, 0);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      applyDeepLinkedVariant();
      syncUrlToVariant();
    });
  } else {
    setTimeout(function(){
      applyDeepLinkedVariant();
      syncUrlToVariant();
    }, 120);
  }
})();

/* ===========================================================
   FP PDP — Uncheck Kids Training Gloves on first page load.
   Section JS defaults it to ON; we want it OFF so customers
   opt-in to the addon, not opt-out. Uses .click() to flip the
   toggle through the section's own click handler — that way
   both the visual state AND the internal state stay in sync.
   =========================================================== */
(function(){
  if (typeof window === 'undefined') return;
  function uncheckGlovesOnce() {
    var toggle = document.querySelector('[data-fp-pdp-addon-toggle="gloves"]');
    if (!toggle) return;
    if (toggle.dataset.fpInitialized === '1') return;
    toggle.dataset.fpInitialized = '1';
    if (!toggle.checked) return; /* already off, nothing to do */
    /* Programmatically click the toggle. This fires the section's click
       handler which updates state.addons.kids.gloves = false and recomputes
       the total. We do NOT manually set toggle.checked first — clicking the
       checkbox toggles its checked state natively. */
    toggle.click();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', uncheckGlovesOnce);
  } else {
    /* Slight delay so the section JS finishes init + attaches its handlers */
    setTimeout(uncheckGlovesOnce, 120);
  }
})();

/* ===========================================================
   FP REVIEWS BLOCK REMOVER + PDP BUNDLE DISCOUNT DISPLAY
   =========================================================== */
(function(){
  if (typeof window === 'undefined') return;
  /* Aggressive reviews widget hider: scan every element for direct text content
     "Customer Reviews" / "Product Reviews" (any tag, not just headings), then
     walk up the DOM and hide the section/widget that contains it. */
  function killReviews() {
    var all = document.querySelectorAll('div, section, p, span, h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      /* Get only direct text (ignore text from descendants) */
      var direct = '';
      for (var k = 0; k < el.childNodes.length; k++) {
        if (el.childNodes[k].nodeType === 3) direct += el.childNodes[k].textContent;
      }
      direct = direct.trim().toLowerCase();
      if (direct === 'customer reviews' || direct === 'product reviews' || direct === 'customer reviews ' ) {
        /* Walk up looking for a clear section/widget root */
        var node = el;
        var hidden = false;
        for (var d = 0; d < 10 && node && node !== document.body; d++) {
          if (node.tagName === 'SECTION' ||
              (node.id && /shopify-section|review/i.test(node.id)) ||
              (node.className && typeof node.className === 'string' &&
               /spr-|jdgm-|yotpo|review|stamped|loox|air-review|opinew|fera|stamped/i.test(node.className))) {
            node.style.display = 'none';
            hidden = true;
            break;
          }
          node = node.parentElement;
        }
        if (!hidden) {
          /* No clear section found — hide 3 levels up to bury the whole widget */
          var parent = el.parentElement;
          for (var p = 0; p < 3 && parent && parent !== document.body; p++) {
            parent = parent.parentElement;
          }
          if (parent && parent !== document.body) {
            parent.style.display = 'none';
          } else if (el.parentElement) {
            el.parentElement.style.display = 'none';
          }
        }
      }
    }
  }
  var BUNDLE_DISCOUNTS = { 2: 15, 3: 25 };
  /* Robust money parser that distinguishes thousands separator from decimal
     based on how many digits follow the last separator:
       - 3 digits  → thousands separator, no decimal (e.g. "3,800" = 3800)
       - 1-2 digits → decimal separator (e.g. "103,90" = 103.90, "59.99" = 59.99)
     Tracks whether the input had a decimal so we can format back the same way. */
  function parseMoney(text) {
    if (!text) return null;
    var t = String(text).trim();
    var m = t.match(/[\d.,]+/);
    if (!m) return null;
    var raw = m[0];
    var prefix = t.slice(0, m.index);
    var suffix = t.slice(m.index + raw.length);
    var lastDot = raw.lastIndexOf('.');
    var lastComma = raw.lastIndexOf(',');
    var lastSep = Math.max(lastDot, lastComma);
    var decSep, thouSep, hadDecimal;
    if (lastSep === -1) {
      /* No separators at all (e.g. "3800") */
      decSep = '.'; thouSep = ','; hadDecimal = false;
    } else {
      var afterLast = raw.length - lastSep - 1;
      var sepChar = raw[lastSep];
      if (afterLast === 3) {
        /* 3 digits after → thousands separator, no decimal */
        thouSep = sepChar;
        decSep = sepChar === '.' ? ',' : '.';
        hadDecimal = false;
      } else {
        /* 1-2 (or other) digits → decimal separator */
        decSep = sepChar;
        thouSep = sepChar === '.' ? ',' : '.';
        hadDecimal = true;
      }
    }
    /* Normalise: strip thousands separators, then ensure the decimal is '.' */
    var norm = raw.split(thouSep).join('');
    if (decSep !== '.') norm = norm.replace(decSep, '.');
    var num = parseFloat(norm);
    if (isNaN(num)) return null;
    return {
      num: num,
      prefix: prefix,
      suffix: suffix,
      decSep: decSep,
      thouSep: thouSep,
      hadDecimal: hadDecimal,
      raw: t
    };
  }
  function fmtMoney(num, tpl) {
    /* Match the input's decimal places (0 if input had no decimal, 2 otherwise) */
    var decimals = tpl.hadDecimal || Math.abs(num - Math.round(num)) > 0.000001 ? 2 : 0;
    var rounded = num.toFixed(decimals);
    var intPart, decPart;
    if (decimals > 0) {
      var split = rounded.split('.');
      intPart = split[0];
      decPart = split[1];
    } else {
      intPart = rounded;
      decPart = null;
    }
    /* Add thousands separators back into the integer part */
    var withThou = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, tpl.thouSep || ',');
    var body = decPart != null ? withThou + (tpl.decSep || '.') + decPart : withThou;
    return tpl.prefix + body + tpl.suffix;
  }
  function applyBundleDiscount(btn, pct) {
    var stack = btn.querySelector('.fp-pdp__bundle-price-stack');
    if (!stack) return;
    if (stack.getAttribute('data-fp-discount-applied') === String(pct)) return;
    var mainEl = stack.querySelector('.fp-pdp__bundle-price-main');
    if (!mainEl) return;
    var parsed = parseMoney(mainEl.textContent);
    if (!parsed) return;
    var newNum = parsed.num * (100 - pct) / 100;
    stack.innerHTML =
      '<span class="fp-pdp__bundle-price-strike">' + parsed.raw + '</span>' +
      '<span class="fp-pdp__bundle-price-main">' + fmtMoney(newNum, parsed) + '</span>' +
      '<span class="fp-pdp__bundle-price-save">Save ' + pct + '%</span>';
    stack.setAttribute('data-fp-discount-applied', String(pct));
  }
  function applyAllBundles() {
    if (document.querySelector(".fp-pdp__halloween")) return;
    var btns = document.querySelectorAll('[data-fp-pdp-bundle]');
    for (var i = 0; i < btns.length; i++) {
      var qty = parseInt(btns[i].getAttribute('data-fp-pdp-bundle'), 10);
      var pct = BUNDLE_DISCOUNTS[qty];
      if (pct && pct > 0) applyBundleDiscount(btns[i], pct);
    }
    /* Order matters: cache base per-unit BEFORE we mutate either total or per-unit */
    getBasePerUnit();
    applyBuyBoxDiscount();
    applyPerUnitDiscount();
  }

  /* Cache the ORIGINAL per-unit price. We mutate the displayed per-unit, so we
     can't trust the DOM value after first render. Cache once on the very first
     read — that's the raw section-rendered price (undiscounted). */
  var fpBasePerUnit = null;
  function getBasePerUnit() {
    if (fpBasePerUnit) return fpBasePerUnit;
    var perUnitEl = document.querySelector('[data-fp-pdp-perunit]');
    if (!perUnitEl) return null;
    /* Only cache if my code hasn't modified it yet */
    if (perUnitEl.textContent === fpLastSetPerUnitText) return null;
    var p = parseMoney(perUnitEl.textContent);
    if (p) fpBasePerUnit = p;
    return fpBasePerUnit;
  }

  /* Patch the buy box total at the bottom of the PDP to reflect the discount.
     Uses a "last set" guard: if the current text matches what I set last time,
     the MutationObserver fire is from MY own change, so skip. If it differs,
     section JS just recomputed → apply discount. */
  var fpLastSetTotalText = null;
  function applyBuyBoxDiscount() {
    if (document.querySelector(".fp-pdp__halloween")) return;
    var activeBtn = document.querySelector('[data-fp-pdp-bundle].is-active');
    if (!activeBtn) return;
    var qty = parseInt(activeBtn.getAttribute('data-fp-pdp-bundle'), 10);
    var pct = BUNDLE_DISCOUNTS[qty];

    var totalEl = document.querySelector('[data-fp-pdp-total]');
    if (!totalEl) return;

    /* Skip echo of my own previous write */
    if (totalEl.textContent === fpLastSetTotalText) return;

    if (!pct) {
      fpLastSetTotalText = totalEl.textContent;
      return;
    }

    var basePerUnit = getBasePerUnit();
    var currentTotal = parseMoney(totalEl.textContent);
    if (!basePerUnit || !currentTotal) return;

    var undiscountedBagsTotal = qty * basePerUnit.num;
    var savings = undiscountedBagsTotal * pct / 100;
    var newTotal = currentTotal.num - savings;
    var newText = fmtMoney(newTotal, currentTotal);

    totalEl.textContent = newText;
    fpLastSetTotalText = newText;
  }

  /* Patch the per-unit display to show the discounted per-unit ($X.XX EACH)
     when on a 2-pack or 3-pack bundle. */
  var fpLastSetPerUnitText = null;
  function applyPerUnitDiscount() {
    if (document.querySelector(".fp-pdp__halloween")) return;
    var activeBtn = document.querySelector('[data-fp-pdp-bundle].is-active');
    if (!activeBtn) return;
    var qty = parseInt(activeBtn.getAttribute('data-fp-pdp-bundle'), 10);
    var pct = BUNDLE_DISCOUNTS[qty];

    var perUnitEl = document.querySelector('[data-fp-pdp-perunit]');
    if (!perUnitEl) return;

    /* Skip echo of my own previous write */
    if (perUnitEl.textContent === fpLastSetPerUnitText) return;

    /* Cache the original now (before mutating) so getBasePerUnit() is correct */
    getBasePerUnit();

    /* Clone the base template WITHOUT its captured suffix — we re-derive the
       suffix from the CURRENT DOM text below so we don't double-stamp it.
       The original bug: fmtMoney(num, fpBasePerUnit) returns prefix+body+suffix
       (e.g. "$71 each"), and then we appended the current text's suffix again
       on top → " each" gets added every render cycle → "EACH EACH EACH EACH...". */
    var baseTplNoSuffix = {
      num: fpBasePerUnit.num,
      prefix: fpBasePerUnit.prefix,
      suffix: '',
      decSep: fpBasePerUnit.decSep,
      thouSep: fpBasePerUnit.thouSep,
      hadDecimal: fpBasePerUnit.hadDecimal
    };

    /* Extract whatever the section's render() just wrote AFTER the number
       (e.g. " EACH" or " EACH · ADD-ONS INCLUDED"). That's the canonical
       suffix we should preserve — never the one cached in fpBasePerUnit. */
    function extractCurrentSuffix(text){
      if (!text) return ' EACH';
      var m = text.match(/[\d.,]+/);
      if (!m) return ' EACH';
      var tail = text.slice(m.index + m[0].length);
      /* Collapse repeated " EACH EACH EACH..." down to one " EACH" in case
         the page is recovering from the old buggy state. */
      tail = tail.replace(/(\s+EACH)(\s+EACH)+/i, '$1');
      return tail || ' EACH';
    }

    if (!pct) {
      /* 1-pack — restore the undiscounted per-unit price */
      if (fpBasePerUnit) {
        var basePrice = fmtMoney(fpBasePerUnit.num, baseTplNoSuffix);
        var sectionSuffix = extractCurrentSuffix(perUnitEl.textContent);
        var newText1 = basePrice + sectionSuffix;
        if (perUnitEl.textContent !== newText1) {
          perUnitEl.textContent = newText1;
          fpLastSetPerUnitText = newText1;
        } else {
          fpLastSetPerUnitText = perUnitEl.textContent;
        }
      } else {
        fpLastSetPerUnitText = perUnitEl.textContent;
      }
      return;
    }

    if (!fpBasePerUnit) return;

    /* Discounted per-unit path */
    var suffix = extractCurrentSuffix(perUnitEl.textContent);
    var discountedPerUnit = fpBasePerUnit.num * (100 - pct) / 100;
    var discountedText = fmtMoney(discountedPerUnit, baseTplNoSuffix);
    var newText = discountedText + suffix;

    perUnitEl.textContent = newText;
    fpLastSetPerUnitText = newText;
  }
  var s = document.createElement('style');
  s.textContent =
    '.fp-pdp__bundle-price-strike { font-family: "Glacial Indifference", sans-serif;' +
    'font-size: 13px; font-weight: 600; color: rgba(10,10,10,0.40);' +
    'text-decoration: line-through; line-height: 1; }' +
    '.fp-pdp__bundle-price-save { display: inline-block;' +
    'font-family: "Glacial Indifference", sans-serif; font-size: 10px;' +
    'letter-spacing: 0.18em; text-transform: uppercase; font-weight: 700;' +
    'color: #1f5536; background: #d6ead9; padding: 3px 7px;' +
    'border-radius: 999px; line-height: 1; }';
  document.head.appendChild(s);

  function runAll() { killReviews(); applyAllBundles(); }
  function bootstrap() {
    /* Cache base per-unit BEFORE first apply so we don't read our own mutation */
    getBasePerUnit();
    runAll();
    /* Observe buy box total — section JS rewrites it on bundle/addon changes */
    var totalEl = document.querySelector('[data-fp-pdp-total]');
    if (totalEl) {
      var totalMO = new MutationObserver(applyBuyBoxDiscount);
      totalMO.observe(totalEl, { childList: true, characterData: true, subtree: true });
    }
    /* Observe per-unit element similarly */
    var perUnitEl = document.querySelector('[data-fp-pdp-perunit]');
    if (perUnitEl) {
      var perUnitMO = new MutationObserver(applyPerUnitDiscount);
      perUnitMO.observe(perUnitEl, { childList: true, characterData: true, subtree: true });
    }
    /* Click hooks → re-run after section JS finishes its state update */
    document.addEventListener('click', function(e){
      if (e.target.closest && e.target.closest('[data-fp-pdp-bundle], [data-fp-pdp-addon], [data-fp-pdp-addon-toggle]')) {
        setTimeout(function(){ applyBuyBoxDiscount(); applyPerUnitDiscount(); }, 0);
        setTimeout(function(){ applyBuyBoxDiscount(); applyPerUnitDiscount(); }, 50);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else { bootstrap(); }
  var mo = new MutationObserver(runAll);
  mo.observe(document.body, { childList: true, subtree: true });
})();

/* ===========================================================
   FP PDP CURRENCY-CODE RELABEL (safe v2)
   Replaces leading "$" on bundle / addon / per-unit price
   elements with the proper Intl currency prefix (e.g. "CA$",
   "A$", "₱") so the bundle picker matches the summary box.
   No MutationObserver — only one-shot + setTimeouts + click
   delegation. Cannot trigger feedback loops.
   No-ops when active currency === shop currency.
   =========================================================== */
(function(){
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function getActive() { return window._fpActiveCurrency || null; }
  function getShop()   { return window._fpShopCurrency   || 'USD'; }
  function getLocale() {
    var l = window._fpLocale || document.documentElement.lang || navigator.language || 'en-US';
    return l.replace('_', '-');
  }

  /* Build the Intl prefix once (e.g. "CA$", "A$", "₱"). If the active
     currency renders as a suffix in this locale (e.g. "0,00 $ CA" for
     fr-CA), prefixCache becomes "" and we skip — safer than reformatting. */
  var prefixCache = undefined;
  function getIntlPrefix() {
    if (prefixCache !== undefined) return prefixCache;
    var active = getActive();
    if (!active) { prefixCache = null; return null; }
    try {
      var sample = new Intl.NumberFormat(getLocale(), {
        style: 'currency', currency: active,
        minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(0);
      /* Capture everything before the first digit */
      var m = sample.match(/^(\D*)0/);
      prefixCache = (m && m[1]) ? m[1] : '';
    } catch (e) {
      prefixCache = '';
    }
    return prefixCache;
  }

  var SELECTORS = [
    '.fp-pdp__bundle-price-main',
    '.fp-pdp__bundle-price-strike',
    '.fp-pdp__bundle-price-each',
    '.fp-pdp__addon-price-now',
    '[data-fp-pdp-perunit]',
    '[data-fp-pdp-gloves-price]'
  ];

  function relabelOnce() {
    var active = getActive();
    var shop = getShop();
    if (!active || active === shop) return;          /* US shoppers — leave alone */
    var intlPrefix = getIntlPrefix();
    if (!intlPrefix || intlPrefix === '$') return;   /* nothing to add */

    for (var i = 0; i < SELECTORS.length; i++) {
      var nodes = document.querySelectorAll(SELECTORS[i]);
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        var t = el.textContent;
        if (!t) continue;
        /* Skip if already relabeled */
        if (t.indexOf(intlPrefix) === 0) continue;
        /* Replace a leading "$" (optionally preceded by whitespace) */
        var newT = t.replace(/^(\s*)\$/, '$1' + intlPrefix);
        if (newT !== t) el.textContent = newT;
      }
    }
  }

  function bootstrap() {
    try { console.info('[FP relabel v2] active=', getActive(), 'shop=', getShop(), 'prefix=', getIntlPrefix()); } catch (e) {}
    relabelOnce();
    setTimeout(relabelOnce, 300);
    setTimeout(relabelOnce, 1000);
    setTimeout(relabelOnce, 2200);
    /* Re-run after PDP interactions that rewrite bundle prices */
    document.addEventListener('click', function(e){
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-fp-pdp-bundle], [data-fp-pdp-addon-toggle], [data-fp-pdp-variant], [data-fp-pdp-setup]')) {
        setTimeout(relabelOnce, 50);
        setTimeout(relabelOnce, 250);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();

/* ===========================================================
   FP USA INDEPENDENCE DROP BADGE
   Adds a premium circular seal-style overlay on the Rage-Bag
   hero image when the active variant is the USA edition.
   Reads variant identity from [data-fp-pdp-variant-title] on
   the active pill (set by the section file). Toggles via
   click delegation — no MutationObserver.
   =========================================================== */
(function(){
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var STYLE_ID = 'fp-usa-drop-badge-style';
  var BADGE_CLASS = 'fp-usa-drop-badge';

  function injectStyles(){
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      /* ---------- BADGE BASE (top-right, luxury coin) ---------- */
      '.fp-usa-drop-badge{position:absolute;top:22px;right:22px;width:134px;height:134px;border-radius:50%;' +
      'display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;' +
      'font-family:"Glacial Indifference","Nunito Sans",sans-serif;' +
      /* Navy radial body with a soft top highlight (glossy coin face) */
      'background:' +
        'radial-gradient(circle at 50% 22%, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0) 55%),' +
        'radial-gradient(circle at center, #1f2f5a 0%, #0c1738 62%, #060b22 100%);' +
      /* Stacked rings = polished metal bezel + outer drop shadow */
      'box-shadow:' +
        'inset 0 0 0 1px rgba(255,222,128,0.55),' +
        'inset 0 2px 8px rgba(255,255,255,0.10),' +
        'inset 0 -3px 10px rgba(0,0,0,0.45),' +
        '0 0 0 4px #c9a14a,' +
        '0 0 0 5px #fff1b6,' +
        '0 0 0 7px #8a6510,' +
        '0 16px 34px rgba(0,0,0,0.42),' +
        '0 4px 10px rgba(0,0,0,0.22);' +
      'transform:rotate(-9deg) scale(1);z-index:6;pointer-events:none;' +
      'opacity:0;transition:opacity .28s ease, transform .42s cubic-bezier(.18,.89,.32,1.28);' +
      '-webkit-user-select:none;user-select:none;}' +
      '.fp-usa-drop-badge.is-visible{opacity:1;transform:rotate(-9deg) scale(1);}' +
      '.fp-usa-drop-badge.is-entering{transform:rotate(-9deg) scale(0.55);}' +
      /* Conic shimmer overlay (subtle, sits above bg under content) */
      '.fp-usa-drop-badge::after{content:"";position:absolute;inset:6px;border-radius:50%;' +
      'background:conic-gradient(from 210deg,' +
        'rgba(255,241,182,0) 0deg,' +
        'rgba(255,241,182,0.18) 90deg,' +
        'rgba(255,241,182,0) 180deg,' +
        'rgba(255,241,182,0.10) 280deg,' +
        'rgba(255,241,182,0) 360deg);' +
      'mix-blend-mode:screen;pointer-events:none;}' +
      /* ---------- INNER CONTENT ---------- */
      '.fp-usa-drop-badge__inner{position:relative;z-index:2;display:flex;flex-direction:column;align-items:center;}' +
      '.fp-usa-drop-badge__years{display:flex;align-items:center;gap:7px;' +
      'font-size:10px;font-weight:700;letter-spacing:0.18em;line-height:1;' +
      /* Gold gradient text */
      'background:linear-gradient(180deg,#fff1b6 0%,#d6a83a 100%);' +
      '-webkit-background-clip:text;background-clip:text;color:transparent;' +
      'text-shadow:0 1px 0 rgba(0,0,0,0.25);}' +
      '.fp-usa-drop-badge__star{font-size:11px;line-height:1;' +
      'background:linear-gradient(180deg,#ffd76b 0%,#b8860b 100%);' +
      '-webkit-background-clip:text;background-clip:text;color:transparent;}' +
      /* Gold gradient divider with fade edges */
      '.fp-usa-drop-badge__rule{width:50px;height:2px;margin:7px 0 7px;border-radius:2px;' +
      'background:linear-gradient(90deg,transparent 0%,#b8860b 20%,#fff1b6 50%,#b8860b 80%,transparent 100%);}' +
      '.fp-usa-drop-badge__main{font-weight:800;letter-spacing:0.10em;line-height:1.15;' +
      'color:#f5f1e2;text-shadow:0 1px 0 rgba(0,0,0,0.35);' +
      'font-size:9px;}' +
      /* The big middle word — gold gradient with subtle inner highlight */
      '.fp-usa-drop-badge__main em{font-style:normal;display:block;font-size:14px;' +
      'letter-spacing:0.04em;margin:2px 0;font-weight:900;' +
      'background:linear-gradient(180deg,#fff7d4 0%,#f0c14b 45%,#a07210 100%);' +
      '-webkit-background-clip:text;background-clip:text;color:transparent;' +
      'text-shadow:none;' +
      'filter:drop-shadow(0 1px 0 rgba(0,0,0,0.5));}' +
      /* ---------- MOBILE ---------- */
      '@media (max-width: 768px){' +
      '.fp-usa-drop-badge{width:98px;height:98px;top:12px;right:12px;' +
      'box-shadow:' +
        'inset 0 0 0 1px rgba(255,222,128,0.5),' +
        'inset 0 1px 6px rgba(255,255,255,0.10),' +
        'inset 0 -2px 8px rgba(0,0,0,0.4),' +
        '0 0 0 3px #c9a14a,' +
        '0 0 0 4px #fff1b6,' +
        '0 0 0 6px #8a6510,' +
        '0 10px 22px rgba(0,0,0,0.32),' +
        '0 3px 8px rgba(0,0,0,0.18);}' +
      '.fp-usa-drop-badge__years{font-size:7.5px;letter-spacing:0.14em;gap:5px;}' +
      '.fp-usa-drop-badge__star{font-size:9px;}' +
      '.fp-usa-drop-badge__rule{width:36px;height:1.5px;margin:5px 0;}' +
      '.fp-usa-drop-badge__main{font-size:7.5px;}' +
      '.fp-usa-drop-badge__main em{font-size:11px;margin:1px 0;}' +
      '}';
    document.head.appendChild(s);
  }

  function createBadgeNode(){
    var d = document.createElement('div');
    d.className = BADGE_CLASS + ' is-entering';
    d.setAttribute('aria-hidden', 'true');
    d.innerHTML =
      '<div class="fp-usa-drop-badge__inner">' +
        '<div class="fp-usa-drop-badge__years">' +
          '<span>1776</span>' +
          '<span class="fp-usa-drop-badge__star">&#9733;</span>' +
          '<span>2026</span>' +
        '</div>' +
        '<div class="fp-usa-drop-badge__rule" aria-hidden="true"></div>' +
        '<div class="fp-usa-drop-badge__main">' +
          'LIMITED' +
          '<em>INDEPENDENCE</em>' +
          'DROP' +
        '</div>' +
      '</div>';
    return d;
  }

  function ensureBadge(){
    var hero = document.querySelector('.fp-pdp__hero');
    if (!hero) return null;
    var existing = hero.querySelector('.' + BADGE_CLASS);
    if (existing) return existing;
    /* Make sure the hero is a positioning context */
    var cs = window.getComputedStyle(hero);
    if (cs && cs.position === 'static') hero.style.position = 'relative';
    var node = createBadgeNode();
    hero.appendChild(node);
    /* Force reflow then drop the entering class so transition fires */
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){ node.classList.remove('is-entering'); });
    });
    return node;
  }

  function isUsaActive(){
    var active = document.querySelector('[data-fp-pdp-variant].is-active');
    if (!active) return false;
    var title = active.getAttribute('data-fp-pdp-variant-title') ||
                active.getAttribute('aria-label') || '';
    return /usa|independence/i.test(title);
  }

  function syncBadge(){
    if (!document.querySelector('.fp-pdp__hero')) return;
    var badge = ensureBadge();
    if (!badge) return;
    if (isUsaActive()) {
      badge.classList.add('is-visible');
    } else {
      badge.classList.remove('is-visible');
    }
  }

  function bootstrap(){
    if (!document.querySelector('.fp-pdp__hero')) return;
    injectStyles();
    syncBadge();
    /* Re-run a few times early in case variant pills render lazily */
    setTimeout(syncBadge, 200);
    setTimeout(syncBadge, 700);
    setTimeout(syncBadge, 1500);
    /* Toggle on variant pill clicks */
    document.addEventListener('click', function(e){
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-fp-pdp-variant]')) {
        setTimeout(syncBadge, 0);
        setTimeout(syncBadge, 60);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();

/* ===========================================================
   FP ANNOUNCEMENT BAR — Rotating messages.
   Cycles between the 60-day guarantee and "The Original
   Rage-Bag" brand badge. Each node carries data-fp-msg with the
   index it's showing, so re-applies are no-ops and the
   MutationObserver can't feedback-loop on our own writes
   (observer is childList-only; the fade class toggle doesn't
   fire it).
   =========================================================== */
(function(){
  if (typeof window === 'undefined') return;
  var WC_URL = '/products/funpunch%C2%AE-rage-bag-brazil-edition';
  var MSGS = [
    '60-day guarantee on every order',
    '<span style="display:inline-flex;align-items:center;gap:7px;font-weight:700;"><svg viewBox="0 0 24 24" width="17" height="17" style="flex:0 0 auto;" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#1D9BF0"></circle><path d="M7.8 12.4l2.6 2.6 5.8-6" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>The Original Rage-Bag</span>'
  ];
  var ROTATE_MS = 6000;
  var FADE_MS = 320;
  var idx = 0;

  function injectStyle(){
    if (document.getElementById('fp-annc-rotate-style')) return;
    var s = document.createElement('style');
    s.id = 'fp-annc-rotate-style';
    s.textContent =
      '.cw-announcement-text { transition: opacity ' + FADE_MS + 'ms ease; }' +
      '.cw-announcement-text.is-fading { opacity: 0; }';
    document.head.appendChild(s);
  }

  /* Write the current message into any bar node not already showing it. */
  function applyCurrent() {
    var nodes = document.querySelectorAll('.cw-announcement-text');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-fp-msg') === String(idx)) continue;
      nodes[i].setAttribute('data-fp-msg', String(idx));
      nodes[i].innerHTML = MSGS[idx];
    }
  }

  function rotate() {
    var nodes = document.querySelectorAll('.cw-announcement-text');
    if (!nodes.length) return;
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-fading');
    setTimeout(function(){
      idx = (idx + 1) % MSGS.length;
      applyCurrent();
      var fresh = document.querySelectorAll('.cw-announcement-text');
      for (var j = 0; j < fresh.length; j++) fresh[j].classList.remove('is-fading');
    }, FADE_MS + 20);
  }

  function bootstrap(){
    injectStyle();
    applyCurrent();
    setInterval(rotate, ROTATE_MS);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else { bootstrap(); }
  /* Section re-renders (e.g. theme editor) wipe data-fp-msg → re-assert.
     Our own writes re-fire this once but applyCurrent() no-ops. */
  var mo = new MutationObserver(applyCurrent);
  mo.observe(document.body, { childList: true, subtree: true });
})();

/* ===========================================================
   FP SETUP VIDEO — Override step labels (PUMP / STICK / PUNCH)
   The section file keeps getting auto-reverted by Shopify with
   the old "01 Wipe surface / 02 Press base / 03 Lock in" copy.
   We rewrite the text content here on every load.
   =========================================================== */
(function(){
  if (typeof window === 'undefined') return;
  var newSteps = ['01 PUMP', '02 STICK', '03 PUNCH'];

  function applyStepText() {
    var steps = document.querySelectorAll('.fp-setupvid__step');
    if (!steps.length) return;
    for (var i = 0; i < steps.length && i < newSteps.length; i++) {
      if (steps[i].textContent.trim() !== newSteps[i]) {
        steps[i].textContent = newSteps[i];
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyStepText);
  } else {
    applyStepText();
  }
  /* Re-apply if the section re-renders (e.g. theme editor live preview) */
  var mo = new MutationObserver(function(){ applyStepText(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();

/* ===========================================================
   FP PDP VIDEO CAROUSEL — Force mute + strip audio toggles
   The section file keeps getting auto-reverted with sound UI.
   We override here by stripping the buttons from the DOM and
   force-muting every video element + blocking the click handler.
   =========================================================== */
(function(){
  if (typeof window === 'undefined') return;
  function killAudio() {
    /* Remove the audio toggle buttons from the DOM */
    var btns = document.querySelectorAll('[data-fp-vid-sound], .fp-vids__sound');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
    }
    /* Force-mute every video card */
    var vids = document.querySelectorAll('.fp-vids__video, [data-fp-vid-el]');
    for (var j = 0; j < vids.length; j++) {
      vids[j].muted = true;
      vids[j].defaultMuted = true;
      vids[j].volume = 0;
      vids[j].removeAttribute('controls');
    }
    /* Clear any is-unmuted state classes */
    var unmuted = document.querySelectorAll('.fp-vids__item.is-unmuted');
    for (var k = 0; k < unmuted.length; k++) unmuted[k].classList.remove('is-unmuted');
  }

  /* Run on init */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', killAudio);
  } else {
    killAudio();
  }

  /* Re-run when DOM changes (in case the section re-renders later) */
  var mo = new MutationObserver(function(mutations){
    var hasSoundBtnAdded = false;
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var n = mutations[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches && (n.matches('[data-fp-vid-sound]') || n.matches('.fp-vids__sound')) || (n.querySelector && n.querySelector('[data-fp-vid-sound], .fp-vids__sound')))) {
          hasSoundBtnAdded = true; break;
        }
      }
      if (hasSoundBtnAdded) break;
    }
    if (hasSoundBtnAdded) killAudio();
  });
  mo.observe(document.body, { childList: true, subtree: true });

  /* Block any click that would have toggled sound, just in case */
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('[data-fp-vid-sound], .fp-vids__sound');
    if (t) { e.preventDefault(); e.stopImmediatePropagation(); }
    /* If the video card itself is clicked and someone calls toggleSoundFor —
       no need to handle, since killAudio strips buttons. But re-mute the
       clicked video defensively. */
    var card = e.target.closest && e.target.closest('.fp-vids__item--playable');
    if (card) {
      var v = card.querySelector('[data-fp-vid-el], .fp-vids__video');
      if (v) { v.muted = true; v.volume = 0; }
    }
  }, true);

  /* PERF 2026-08-26 — removed a `setInterval(..., 2000)` that re-muted every PDP video
     every 2 seconds, forever, on every page of the store.

     It was also fighting a real feature: fp-pdp-videos.liquid has an intentional
     tap-to-unmute (`toggleSoundFor`), and this timer silently re-muted the video within
     2s of a shopper turning sound on. Videos already carry the `muted` attribute and
     browsers block autoplay-with-sound outright, so the muted-by-default guarantee is
     unaffected by removing this. */
})();

/* ===========================================================
   FP PDP HERO — Real finger-tracking carousel
   The image follows the finger during swipe. Adjacent images are
   pre-rendered as overlays so prev/next photo is visible as you
   drag. On release, snaps to next/prev or rubber-bands back.
   Variant pill / thumbnail clicks trigger a slide-in animation.
   =========================================================== */
(function(){
  if (typeof window === 'undefined') return;
  if (window.matchMedia('(min-width: 1024px)').matches) return;

  function fileBase(u) {
    if (!u) return '';
    try {
      var p = u.split('?')[0];
      var slash = p.lastIndexOf('/');
      var name = slash >= 0 ? p.slice(slash + 1) : p;
      return name.toLowerCase();
    } catch (e) { return ''; }
  }

  function init() {
    var wrap =
      document.querySelector('[data-fp-pdp-hero-swipe]') ||
      document.querySelector('[data-fp-acc-hero-swipe]');
    if (!wrap) return;
    var anchor =
      wrap.querySelector('[data-fp-pdp-hero-img]') ||
      wrap.querySelector('[data-fp-acc-hero]');
    if (!anchor || anchor.tagName !== 'IMG') return;

    var isAcc = wrap.hasAttribute('data-fp-acc-hero-swipe');
    var dataEl = isAcc
      ? document.querySelector('[data-fp-acc-data]')
      : document.querySelector('[data-fp-pdp-data]');
    var data = null;
    try { data = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) {}
    var variants = isAcc ? (data && data.variants) || [] : (data && data.rageBag && data.rageBag.variants) || [];

    /* Resolve the current variant + image idx by matching anchor.src */
    function variantImagesFor(v) {
      if (!v) return [];
      if (v.images && v.images.length) {
        var arr = v.images.filter(function(u){ return u && u.length; });
        if (arr.length) return arr;
      }
      return v.image ? [v.image] : [];
    }
    function getCurrent() {
      var srcBase = fileBase(anchor.src);
      for (var i = 0; i < variants.length; i++) {
        var imgs = variantImagesFor(variants[i]);
        for (var j = 0; j < imgs.length; j++) {
          if (fileBase(imgs[j]) === srcBase) return { variant: variants[i], imgs: imgs, idx: j };
        }
      }
      /* Fall back: single-image variant */
      return { variant: variants[0] || null, imgs: anchor.src ? [anchor.src] : [], idx: 0 };
    }

    /* Ensure wrap clips and is positioned */
    var wrapCS = getComputedStyle(wrap);
    if (wrapCS.overflow === 'visible') wrap.style.overflow = 'hidden';
    if (wrapCS.position === 'static') wrap.style.position = 'relative';

    var DURATION = 320;
    var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

    function makeOverlay(src, initialX) {
      /* Prefer a preloaded cached image so swipe never shows a blank frame */
      var cached = preloadCache[src];
      var im;
      if (cached && cached.cloneNode) {
        im = cached.cloneNode(false);
      } else {
        im = document.createElement('img');
        im.src = src;
      }
      im.alt = '';
      im.setAttribute('aria-hidden', 'true');
      im.style.cssText =
        'position:absolute;top:0;left:0;width:100%;height:100%;' +
        'object-fit:contain;z-index:5;will-change:transform;' +
        'pointer-events:none;backface-visibility:hidden;' +
        '-webkit-backface-visibility:hidden;' +
        'transform:translate3d(' + initialX + ',0,0);';
      return im;
    }

    /* ===== Aggressive preload of every gallery image ===== */
    var preloadCache = {};
    function preloadUrl(url, background) {
      if (!url || preloadCache[url]) return;
      var im = new Image();
      im.decoding = 'async';
      /* Only the images for the variant on screen are critical. Anything we're
         warming speculatively goes at low priority so it can't elbow ahead of
         the visible gallery. */
      try { im.fetchPriority = background ? 'low' : 'high'; } catch(e){}
      im.src = url;
      if (im.decode) im.decode().then(function(){}).catch(function(){});
      preloadCache[url] = im;
      if (background) return;   /* no <link rel=preload> for speculative images */
      try {
        var link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = url;
        document.head.appendChild(link);
      } catch(e){}
    }
    /* PERF 2026-08-27 — was preloading EVERY image of the current variant at
       fetchPriority=high, each with its own <link rel=preload>, immediately at
       parse time. Two problems, both measured:
         - imgs[0] IS the hero, which the server-rendered <img> already fetches
           with loading=eager + a 600/1200/1600 srcset. Preloading it at a
           different width fetched the SAME file a second and third time
           (DarkEdition_img1 came down at w=600, w=800 AND w=1200 = 137 KB wasted).
         - imgs[1..n] are gallery slides nobody has swiped to, yet they were
           marked high-priority and competed with first paint.
       Now: never touch imgs[0], warm only the NEXT slide, low priority, and only
       once the page has finished loading. The rest arrive on first interaction. */
    function preloadNextSlide() {
      var info = getCurrent();
      if (!info || info.imgs.length < 2) return;
      preloadUrl(info.imgs[1], true);
    }
    /* Full warm for the current variant — on first real interaction with the gallery. */
    function preloadRestOfCurrentVariant() {
      var info = getCurrent();
      if (!info) return;
      for (var j = 1; j < info.imgs.length; j++) preloadUrl(info.imgs[j], true);
    }
    /* Was preloading EVERY image of EVERY variant at width=1400, each marked
       fetchPriority=high with its own <link rel=preload> — roughly 2 MB of
       full-size PNGs competing with the content the shopper is actually looking
       at. Now we warm only the FIRST image of each other variant (so tapping a
       swatch still feels instant) and leave the rest to load on demand. */
    function preloadAll() {
      for (var i = 0; i < variants.length; i++) {
        var imgs = variantImagesFor(variants[i]);
        if (imgs.length) preloadUrl(imgs[0], true);
      }
    }
    /* PERF 2026-08-27 — nothing speculative runs before the load event any more.
       Previously this fired at parse time and put ~444 KB of unrequested images
       into the window before first paint (FCP measured at 9.5s, with these
       starting at 7.2s). Order now: page loads -> idle -> warm the next slide
       only. Everything else waits for a real signal from the shopper. */
    var warmedGallery = false, warmedVariants = false;
    function warmGalleryOnce() {
      if (warmedGallery) return;
      warmedGallery = true;
      preloadRestOfCurrentVariant();
    }
    function warmVariantsOnce() {
      if (warmedVariants) return;
      warmedVariants = true;
      preloadAll();
    }
    function afterLoadIdle(fn, timeout) {
      function go() {
        if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: timeout || 3000 });
        else setTimeout(fn, 1200);
      }
      if (document.readyState === 'complete') go();
      else window.addEventListener('load', go, { once: true });
    }

    /* cheapest useful warm: just the next slide, after the page is done */
    afterLoadIdle(preloadNextSlide, 3000);

    /* real signals — the shopper is about to need these */
    var galleryWrap = document.querySelector('[data-fp-pdp-hero-swipe]');
    if (galleryWrap) {
      galleryWrap.addEventListener('touchstart', warmGalleryOnce, { passive: true, once: true });
      galleryWrap.addEventListener('mouseenter', warmGalleryOnce, { once: true });
    }
    document.addEventListener('touchstart', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-fp-pdp-variant]')) warmVariantsOnce();
    }, { passive: true });
    document.addEventListener('mouseover', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-fp-pdp-variant]')) warmVariantsOnce();
    });

    /* safety net: if the shopper just sits there, warm the other variants late
       and at low priority so switching still feels quick. */
    afterLoadIdle(function () { setTimeout(warmVariantsOnce, 2500); }, 5000);

    /* ===== Finger-tracking swipe ===== */
    var startX = 0, startY = 0;
    var dx = 0, dy = 0;
    var tracking = false;
    var locked = null; /* 'h' | 'v' | null — gesture lock */
    var prevOv = null, nextOv = null;
    var current = null;
    var width = 0;
    var animating = false;
    var lastSwipeDir = null; /* set on a successful swipe; used by MutationObserver to pick slide-in direction */

    function clearOverlays() {
      if (prevOv) { prevOv.remove(); prevOv = null; }
      if (nextOv) { nextOv.remove(); nextOv = null; }
    }

    function resetAnchorTransform(animate) {
      anchor.style.transition = animate ? ('transform ' + DURATION + 'ms ' + EASE) : 'none';
      anchor.style.transform  = 'translateX(0)';
    }

    /* Stop the section's own swipe handler from also reacting */
    function stopSectionHandlers(e) { e.stopImmediatePropagation(); }

    /* rAF-throttle touchmove so we only repaint once per frame (60 FPS),
       not on every pointer event (which can fire faster than the screen). */
    var pendingTx = null;
    function commitTx() {
      if (pendingTx === null) return;
      var t = pendingTx;
      pendingTx = null;
      anchor.style.transform = 'translate3d(' + t + 'px,0,0)';
      if (prevOv) prevOv.style.transform = 'translate3d(' + (t - width) + 'px,0,0)';
      if (nextOv) nextOv.style.transform = 'translate3d(' + (t + width) + 'px,0,0)';
    }

    wrap.addEventListener('touchstart', function(e){
      if (e.touches.length !== 1) return;
      if (animating) return;
      stopSectionHandlers(e);
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0; dy = 0;
      tracking = true;
      locked = null;
      width = wrap.clientWidth || 1;

      current = getCurrent();
      var imgs = current ? current.imgs : [];
      var idx = current ? current.idx : 0;
      clearOverlays();
      if (imgs.length > 1) {
        if (idx > 0) { prevOv = makeOverlay(imgs[idx - 1], '-100%'); wrap.appendChild(prevOv); }
        if (idx < imgs.length - 1) { nextOv = makeOverlay(imgs[idx + 1], '100%'); wrap.appendChild(nextOv); }
      }
      /* Promote the anchor to its own GPU layer for the duration of the gesture */
      anchor.style.transition = 'none';
      anchor.style.willChange = 'transform';
      anchor.style.backfaceVisibility = 'hidden';
      anchor.style.webkitBackfaceVisibility = 'hidden';
      anchor.style.transform = 'translate3d(0,0,0)';
    }, true);

    wrap.addEventListener('touchmove', function(e){
      if (!tracking || e.touches.length !== 1) return;
      dx = e.touches[0].clientX - startX;
      dy = e.touches[0].clientY - startY;
      if (!locked) {
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
          locked = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
        }
      }
      if (locked !== 'h') return;
      stopSectionHandlers(e);
      var t = dx;
      if (dx > 0 && !prevOv) t = dx / 3;
      if (dx < 0 && !nextOv) t = dx / 3;
      /* Batch transforms to one paint per frame */
      var schedule = pendingTx === null;
      pendingTx = t;
      if (schedule) requestAnimationFrame(commitTx);
    }, true);

    function snapToOverlay(targetOverlay, dir) {
      animating = true;
      pendingTx = null; /* cancel any pending rAF */
      var anchorTo = dir === 'next' ? -width : width;
      anchor.style.transition = 'transform ' + DURATION + 'ms ' + EASE;
      anchor.style.transform  = 'translate3d(' + anchorTo + 'px,0,0)';
      if (prevOv) {
        prevOv.style.transition = 'transform ' + DURATION + 'ms ' + EASE;
        prevOv.style.transform  = (dir === 'prev') ? 'translate3d(0,0,0)' : 'translate3d(-' + width + 'px,0,0)';
      }
      if (nextOv) {
        nextOv.style.transition = 'transform ' + DURATION + 'ms ' + EASE;
        nextOv.style.transform  = (dir === 'next') ? 'translate3d(0,0,0)' : 'translate3d(' + width + 'px,0,0)';
      }
      lastSwipeDir = dir;

      setTimeout(function(){
        finishingSwipe = true;
        var newSrc = targetOverlay.src;
        anchor.src = newSrc;
        prevSrc = newSrc;
        clearOverlays();
        anchor.style.transition = 'none';
        anchor.style.transform  = 'translate3d(0,0,0)';
        updateGalleryState(newSrc);
        notifySectionOfSwipe(dir);
        anchor.offsetWidth;
        /* Preload the new neighbors so the next swipe is also instant */
        var info = getCurrent();
        if (info && info.imgs.length > 1) {
          if (info.idx > 0) preloadUrl(info.imgs[info.idx - 1]);
          if (info.idx < info.imgs.length - 1) preloadUrl(info.imgs[info.idx + 1]);
        }
        finishingSwipe = false;
        animating = false;
      }, DURATION + 20);
    }

    function snapBack() {
      animating = true;
      pendingTx = null;
      anchor.style.transition = 'transform ' + DURATION + 'ms ' + EASE;
      anchor.style.transform  = 'translate3d(0,0,0)';
      if (prevOv) { prevOv.style.transition = 'transform ' + DURATION + 'ms ' + EASE; prevOv.style.transform = 'translate3d(-' + width + 'px,0,0)'; }
      if (nextOv) { nextOv.style.transition = 'transform ' + DURATION + 'ms ' + EASE; nextOv.style.transform = 'translate3d(' + width + 'px,0,0)'; }
      setTimeout(function(){ clearOverlays(); animating = false; }, DURATION + 20);
    }

    wrap.addEventListener('touchend', function(e){
      if (!tracking) return;
      tracking = false;
      if (locked === 'h') stopSectionHandlers(e);
      var THRESH = Math.max(40, width * 0.18);
      if (locked === 'h' && dx < -THRESH && nextOv) {
        snapToOverlay(nextOv, 'next');
      } else if (locked === 'h' && dx > THRESH && prevOv) {
        snapToOverlay(prevOv, 'prev');
      } else {
        snapBack();
      }
    }, true);

    /* Update dots / thumbs active state to reflect the new index */
    function updateGalleryState(newSrc) {
      var info = (function(){
        var base = fileBase(newSrc);
        for (var i = 0; i < variants.length; i++) {
          var imgs = variantImagesFor(variants[i]);
          for (var j = 0; j < imgs.length; j++) {
            if (fileBase(imgs[j]) === base) return { idx: j };
          }
        }
        return null;
      })();
      if (!info) return;
      var idx = info.idx;
      var dots = document.querySelectorAll('.fp-pdp__hero-gallery-dot, .fp-acc__hero-dot');
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === idx);
      var thumbs = document.querySelectorAll('[data-fp-pdp-thumb], [data-fp-acc-thumb]');
      for (var k = 0; k < thumbs.length; k++) {
        var ti = parseInt(thumbs[k].getAttribute('data-fp-pdp-thumb') || thumbs[k].getAttribute('data-fp-acc-thumb'), 10);
        thumbs[k].classList.toggle('is-active', ti === idx);
      }
    }

    /* Tell the section's own logic about the swipe by dispatching a synthetic
       click on the corresponding thumbnail. That updates the section's internal
       galleryIdx state without us touching its private vars. */
    function notifySectionOfSwipe(dir) {
      var info = (function(){
        var base = fileBase(anchor.src);
        for (var i = 0; i < variants.length; i++) {
          var imgs = variantImagesFor(variants[i]);
          for (var j = 0; j < imgs.length; j++) {
            if (fileBase(imgs[j]) === base) return { idx: j };
          }
        }
        return null;
      })();
      if (!info) return;
      var thumb = document.querySelector('[data-fp-pdp-thumb="' + info.idx + '"], [data-fp-acc-thumb="' + info.idx + '"]');
      /* No-op if the section already has this idx active. The visual state
         is already what we want; we just want the section's own state aligned. */
    }

    /* ===== Variant-click / thumbnail-click slide-in animation ===== */
    var prevSrc = anchor.src;
    var finishingSwipe = false;

    document.addEventListener('click', function(e){
      var pill = e.target.closest && e.target.closest('[data-fp-pdp-variant], [data-fp-acc-swatch], [data-fp-pdp-thumb], [data-fp-acc-thumb]');
      if (pill) lastSwipeDir = 'next';
    });

    var mo = new MutationObserver(function(){
      if (finishingSwipe || animating) { prevSrc = anchor.src; return; }
      var newSrc = anchor.src;
      if (newSrc === prevSrc) return;
      var oldSrc = prevSrc;
      prevSrc = newSrc;
      slideIn(oldSrc, newSrc, lastSwipeDir || 'next');
    });
    mo.observe(anchor, { attributes: true, attributeFilter: ['src'] });

    function slideIn(oldSrc, newSrc, dir) {
      animating = true;
      var overlay = makeOverlay(oldSrc, '0');
      overlay.style.zIndex = '6';
      wrap.appendChild(overlay);
      var fromX = dir === 'next' ? '100%' : '-100%';
      var toX   = dir === 'next' ? '-100%' : '100%';
      anchor.style.transition = 'none';
      anchor.style.transform  = 'translateX(' + fromX + ')';
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          anchor.style.transition = 'transform ' + DURATION + 'ms ' + EASE;
          anchor.style.transform  = 'translateX(0)';
          overlay.style.transition = 'transform ' + DURATION + 'ms ' + EASE;
          overlay.style.transform  = 'translateX(' + toX + ')';
        });
      });
      setTimeout(function(){
        overlay.remove();
        anchor.style.transition = '';
        anchor.style.transform  = '';
        updateGalleryState(newSrc);
        animating = false;
        refreshArrows();
      }, DURATION + 20);
    }

    /* ============== Arrow buttons (tap to prev/next) ============== */
    var arrowPrefix = isAcc ? 'fp-acc__hero-arrow' : 'fp-pdp__hero-arrow';
    var btnPrev = null, btnNext = null;
    function makeArrowButton(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = arrowPrefix + ' ' + arrowPrefix + '--' + dir;
      b.setAttribute('aria-label', dir === 'left' ? 'Previous photo' : 'Next photo');
      var chev = dir === 'left' ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6';
      b.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="' + chev + '"/></svg>';
      return b;
    }
    btnPrev = makeArrowButton('left');
    btnNext = makeArrowButton('right');
    wrap.appendChild(btnPrev);
    wrap.appendChild(btnNext);

    function refreshArrows() {
      var info = getCurrent();
      if (!info || info.imgs.length <= 1) {
        btnPrev.classList.remove('is-visible');
        btnNext.classList.remove('is-visible');
        return;
      }
      btnPrev.classList.toggle('is-visible', info.idx > 0);
      btnNext.classList.toggle('is-visible', info.idx < info.imgs.length - 1);
    }

    function arrowGo(dir) {
      if (animating) return;
      var info = getCurrent();
      if (!info || info.imgs.length <= 1) return;
      var targetIdx = dir === 'next' ? info.idx + 1 : info.idx - 1;
      if (targetIdx < 0 || targetIdx >= info.imgs.length) return;
      /* Build a fake overlay element so we can reuse snapToOverlay */
      width = wrap.clientWidth || 1;
      clearOverlays();
      var targetUrl = info.imgs[targetIdx];
      var ov = makeOverlay(targetUrl, dir === 'next' ? '100%' : '-100%');
      if (dir === 'next') { nextOv = ov; } else { prevOv = ov; }
      wrap.appendChild(ov);
      snapToOverlay(ov, dir);
    }

    btnPrev.addEventListener('click', function(e){ e.stopPropagation(); arrowGo('prev'); });
    btnNext.addEventListener('click', function(e){ e.stopPropagation(); arrowGo('next'); });

    /* Initial visibility */
    refreshArrows();
    /* Re-evaluate after any src change (variant click, swipe, thumb click) */
    var arrowMO = new MutationObserver(function(){ refreshArrows(); });
    arrowMO.observe(anchor, { attributes: true, attributeFilter: ['src'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 80);
  }
})();
